import { CommonModule } from '@angular/common';
import { Component, inject, OnInit, ViewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Store } from '@ngrx/store';
import { MessageService } from 'primeng/api';
import { Observable } from 'rxjs';
import { ZorroTableComponent } from '../../../components/common/custom-table/zorro-table.component';
import { MenuDropdownComponent } from '../../../components/common/menu-dropdown/menu-dropdown.component';
import { CautionAlertModalComponent } from '../../../components/modal-templates/caution-alert-modal/caution-alert-modal.component';
import { ExecutionReleaseModalComponent } from '../../../components/modal-templates/execution-release-modal/execution-release-modal.component';
import { SharedComponents } from '../../../components/shared.module';
import { Release } from '../../../core/models/release-fields';
import { selectRelease } from '../../../core/ngrx/selectors/release.selectors';
import { ProjectService } from '../../../core/services/project/project.service';
import { RestService } from '../../../core/services/rest.service';
import { SideNavService } from '../../../core/services/side-nav/side-nav.service';
import { ToasterService } from '../../../core/services/toaster-service';
import { MaterialModule } from '../../../core/shared/material.module';
import { testAgentConfig, testBrowserConfig, testBrowserSections } from '../../../core/table-templates/agent-browser-dropdown';
import { testExecutionColumns } from '../../../core/table-templates/test-execution-table';
import { MessageEnum } from '../../../core/utils/message.enum';

@Component({
  selector: "app-test-execution",
  standalone: true,
  imports: [
    SharedComponents,
    MatIconModule,
    CommonModule,
    MaterialModule,
    FormsModule,
    MenuDropdownComponent
  ],
  templateUrl: "./test-execution.component.html",
  styleUrl: "./test-execution.component.scss",
})
export class TestExecutionComponent implements OnInit {
  agentConfig: any = testAgentConfig;
  agentValue: string = "";
  agentSections: any = [];
  browserValue: string = "";
  browsersConfig: any = testBrowserConfig;
  browsersSections: any = testBrowserSections;
  testCaseTreeData: any = [];
  testPlanTreeData: any = [];
  testCaseTree = "test-case-tree";
  testPlanTree = "test-plan-tree";
  testPlansForExecution: any = [];
  dataSource: any = [];
  columns: any = testExecutionColumns;
  selectedAvailableItems = [];
  selectedSelectedItems = [];
  projectId: any;
  automationProjectId: any;
  isDataLoaded: boolean = false;
  tableOptions: any = {
    expandable: true
  }
  selectedCase: any = {
    id: ""
  };
  selectedPlans: any = [];
  selectedCases: any = [];
  selectedPlan: any = {
    id: ""
  };
  @ViewChild(ZorroTableComponent) zorroTableComponent!: ZorroTableComponent;
  caseTreeSearch: any = "";
  caseSearchResults: any[] = [];
  planTreeSearch: any = "";
  planSearchResults: any[] = [];
  agentIdWithType: any = {};
  isAnalysUp: boolean = false;
  isSelfHealingUp: boolean = false;
  private messageService = inject(MessageService);
  private modalService = inject(NgbModal);
  releases$: Observable<Release[]> = this.store.select(selectRelease);
  releases: any;
  warningMessage: string = "";
  devices: any = [];
  globalEngines: any = [];

  constructor(
    private restService: RestService,
    private projectService: ProjectService,
    private sideNav: SideNavService,
    private store: Store,
    private readonly toaster: ToasterService
  ) {
    this.projectService.getProjectId().subscribe((id) => {
      this.projectId = id;
    });
    this.projectService.getAutomationProjectId().subscribe((id: any) => {
      this.automationProjectId = id;
    });
  }
  ngOnInit(): void {
    this.getTestPlansAndTestSuits();

    this.releases$.subscribe((data: any[]) => {
      this.releases = data?.map((release) => ({
        value: release.id,
        label: release.name
      })) || [];
    });
  }

  getLatestTestCaseVersion(versions: any[]): string | null {
    if (!versions?.length) return null;
    const latest = versions.reduce((latest, current) =>
      current.increment > latest.increment ? current : latest
    , versions[0]);
    return latest.version || null;
  }

  onSwitchChange(event: any) {
   if(this.isAnalysUp){
      this.getConfiguredLLMs();
   }
  }
  
  
  getConfiguredLLMs(){
    this.restService.getLLMConfs(this.projectId).subscribe((response: any) => {
      if (response?.data?.isCommonLLM) {
        console.log("LLM configured globally!")
       } else if(response?.data?.applicationLLMs){
        const configuredLLms = response?.data?.applicationLLMs;
        const key = 'testFailureAnalysis';

        if (key in configuredLLms) {
          //asset mapped true, checking llm configuration in mapped assets
          if(configuredLLms[key]?.llmId === null || configuredLLms[key]?.llmId === undefined){
            let modalRef = this.modalService.open(CautionAlertModalComponent, {
              centered: true,
              size: "sm",
              backdrop: "static",
            });
            modalRef.componentInstance.configs = {
            title: "Incomplete Setup",
            subTitle: "Please configure the LLM connection to Test Failure Analyzer before proceeding with asset actions."
            };
            modalRef.result.then((result: any) => {});
          }
        } 
      } else{
        console.log("Warning: No LLMs configured!")
      }
    }, error => {
      console.log("Error occurred while getting the configurred llms!");
    });
  }

  getTestPlans() {
    this.restService.getTestPlansWithVersions(this.projectId, this.automationProjectId).subscribe((response) => {
      this.isDataLoaded = true;
      let data = response.data;
      let plan: any;
      let plans = [];
      for (let i = 0; i < data.length; i++) {
        plan = data[i];
        let currentCase;
        let currentPlan: any = {
          id: plan.id,
          name: plan.name,
          displayName: plan.name,
          tcgTestCaseResultId: "",
          order: 0,
          level: 0,
          active: plan.active,
          // icon:'folder',
          children: [],
          "dragable": true
        }
        for (let j = 0; j < plan.testScripts.length; j++) {
          currentCase = plan.testScripts[j];
          currentCase = {
            id: currentCase.id,
            name: currentCase.name,
            displayName: currentCase.name,
            tcgTestCaseResultId: currentCase.tcgTestCaseResultId ? currentCase.tcgTestCaseResultId : null,
            order: 0,
            level: 2,
            // icon:'draft',
            agentId: currentCase.agentId,
            browser: currentCase.browser,
            increment: currentCase.increment,
            scriptId: currentCase.scriptId,
            sequence: currentCase.sequence,
            selectedVersion: this.getLatestTestCaseVersion(currentCase.versions),
            // selectedVersion:currentCase.version,
            "versionList": this.buildVersions(currentCase.versions),
            "dragable": false
          }
          currentPlan.children.push(currentCase);
        }
        plans.push(currentPlan);
      }
      this.testPlanTreeData = [...plans];
    }, (error) => {
      this.isDataLoaded = true;
    });
  }

  buildVersions(data: any[]) {
    let versions: any = [];
    data.forEach((ver: any) => {
      versions.push({
        label: ver.version,
        value: ver.version
      })
    })
    return [{
      label: "",
      options: versions
    }]
  }

  getTestPlansAndTestSuits() {
    this.restService.getTestSuitsAndTestCases(this.projectId, this.automationProjectId).subscribe((response) => {
      let data = response?.data?.filter((item: any) => item.type === 'SCRIPT');
      let suits: any = [];
      let cases: { id: any; name: any; scriptId: any; displayName: any; icon: string; order: number; level: number; type: any; active: any; children?: never[]; }[] = [];
      this.getAgentsWithStatus();
      data.forEach((item: any) => {
        let currentCase: any = {
          "id": item.id,
          "name": item.name,
          "scriptId": item.scriptId,
          "displayName": item.name,
          "icon": "draft",
          "order": 0,
          "level": 1,
          "type": item.type,
          "tcgTestCaseResultId": item.tcgTestCaseResultId ? item.tcgTestCaseResultId : null,
          "active": item.active,
          "selectedVersion": item.version,
          "versionList": this.buildVersions(item.versions),
          version: item.version,
          "dragable": true.valueOf,
        };
        if (item.automationScriptGroup) {
          let suit = {
            ...item.automationScriptGroup,
            children: [],
            icon: 'folder',
            displayName: item.automationScriptGroup.name,
            order: 0,
            level: 0,
            "dragable": false
          };
          let index = suits.findIndex((suitItem: any) => suitItem.id === suit.id);

          currentCase.level = 2;
          if (index > -1) {
            suits[index].children.push(currentCase);
          } else {
            suit.children.push(currentCase);
            suits.push(suit)
          }
        } else {
          currentCase.order = 0;
          currentCase.level = 0;
          if (currentCase.type === 'SCRIPT' || currentCase.type === 'REUSABLE_SCRIPT') {
            currentCase.level = 2;
          }
          cases.push(currentCase);
        }
      });
      this.testCaseTreeData = [...suits, ...cases]
    }, (error) => {
      this.toaster.pop({ type: 'error', text: MessageEnum.TEST_CASE_LOAD_FAILURE });
      this.isDataLoaded = true;
    });
  }

  getDeviceList() {
    this.restService.getDevices(this.projectId).subscribe((res: any) => {
      let types: any = [];
      res?.data.forEach((ele: any) => {
        if(!types.includes(ele.environment)) {
          types.push(ele.environment);
        }
      });
      types.forEach((ele: any) => {
        this.devices.push({
          label: `${ele} Device`,
          options: res.data?.filter((item: any) => item.environment === ele)?.map((subItem: any) => {
            return {
              ...subItem,
              label: subItem.name
            }
          })
        });
      });
      this.constructTable();
    }, error => {
      this.constructTable();
      this.toaster.pop({ type: 'error', text: error.message || MessageEnum.DEVICE_LOAD_FAILURE });
    });
  }

  getAgentsWithStatus() {
    this.restService.getAgentsWithStatus(this.projectId).subscribe((response) => {
      let localAgents: { label: any; icon: string; value: any; }[] = [];
      let cloudAgents: { label: any; icon: string; value: any; }[] = [];
      let data = response?.data;
      this.getTestPlans();
      data.forEach((agent: any) => {
        let currentAgent = {
          "label": agent.name,
          "icon": agent.status === "OFFLINE" ? "assets/images/agent/agent-dead.svg" : "assets/images/agent/agent-alive.svg",
          "value": agent.id,
          agentType: agent.type,
        };
        this.agentIdWithType[agent.id] = agent.type;
        agent.type == 'LOCAL' ? localAgents.push(currentAgent) : cloudAgents.push(currentAgent);
      });
      this.agentSections.push({
        label: "",
        type: 'onDemand',
        options: [
          {
            label: 'On Demand',
            icon: "assets/images/agent/agent-alive.svg",
            value: 'onDemand',
            agentType: 'CLUSTER'
          }
        ]
      })
      if (localAgents.length) {
        this.agentSections.push({
          label: "Local Execution Engines",
          type: 'LOCAL',
          options: localAgents
        })
      }
      if (cloudAgents.length) {
        this.agentSections.push({
          label: "Cloud Based Execution Engines",
          type: 'CLUSTER',
          options: cloudAgents
        })
      }
      this.getDeviceList();
    }, (error) => {
      this.isDataLoaded = true;
      this.toaster.pop({ type: 'error', text: MessageEnum.AGENT_LOAD_FAILURE });
    });
  }

  selectCase($event: any) {
    if ($event.dragable) {
      this.selectedCase = $event;
    }
  }

  selectPlan($event: any) {
    if ($event.dragable) {
      this.selectedPlan = $event;
    }
  }

  constructTable() {
    let agentColumn = this.columns.filter((column: any) => { return column.key == 'agent' });
    let browserColumn = this.columns.filter((column: any) => { return column.key == 'browser' });

    if (agentColumn.length)
      agentColumn[0]._config.componentInputs.fields[0].options = this.devices;
      agentColumn[0]._config.componentInputs.fields[1].options = this.agentSections;
      this.globalEngines = agentColumn[0]._config.componentInputs.fields;
    if (browserColumn.length)
      browserColumn[0]._config.componentInputs.fields = this.browsersSections;
  }

  updateGlobalAgent(event: any) {
    let val = event?.value || event?.id;
    this.testPlansForExecution.forEach((plan: any) => {
      for (let i = 0; i < plan.children.length; i++) {
        let currentCase = plan.children[i];
        if(event?.agentType) {
          currentCase.agentId = val;
          currentCase.agentType = event.agentType;
          currentCase.executionType = 'WEB';
        } else {
          currentCase.deviceId = val;
          currentCase.agentType = undefined;
          currentCase.executionType = 'MOBILE';
        }
      }
    });
    this.dataSource.forEach((row: any) => {
      if(event?.agentType) {
        row.selectedAgentDevice = val;
        row.agentId = val;
        row.agentType = event.agentType;
      } else {
        row.deviceId = val;
        row.selectedAgentDevice = val;
        row.agentType = undefined;
      }

      row.children?.forEach((child: any) => {
        if(event?.agentType) {
          child.selectedAgentDevice = val;
          child.agentId = val;
          child.agentType = event.agentType;
        } else {
          child.deviceId = val;
          child.selectedAgentDevice = val;
          child.agentType = undefined;
        }
      });
    });
    this.zorroTableComponent.refreshTableData();

  }
  updateGlobalBrowser(event: any) {
    this.testPlansForExecution.forEach((plan: any) => {
      for (let i = 0; i < plan.children.length; i++) {
        let currentCase = plan.children[i];
        currentCase.browser = event.value;
      }
    });
    this.dataSource.forEach((row: any) => {
      row.selectedBrowser = event.value;
      row.children?.forEach((child: any) => {
        child.selectedBrowser = event.value;
      });
    });
    this.zorroTableComponent.refreshTableData();
  }

  moveSelected(type: string, items?: string) {
    switch (type) {
      //rowId relevent changes
      case 'case':
        this.drop({
          item: {
            data: this.selectedCase
          }
        });
        this.selectedCase = {
          id: ""
        }
        break;
      case 'plan':
        this.drop({
          item: {
            data: this.selectedPlan
          }
        });
        this.selectedPlan = {
          id: ""
        }
        break;
      case 'remove':
        if (items == 'cases') {
          this.testPlansForExecution = this.testPlansForExecution.filter((row: any) => {
            return row.planName != "AdHocTestplan";
          });
          this.buildDataSourceFromObject();
          this.selectedCases = [];
        } else {
          let planIds: string[] = [];
          this.selectedPlans.forEach((id: string) => {
            planIds.push(id.split('_row_')[1]);
          })
          this.testPlansForExecution = this.testPlansForExecution.filter((row: any) => {
            return !planIds.includes(row.id);
          });
          this.buildDataSourceFromObject();
          this.selectedPlans = [];
        }
        this.zorroTableComponent.refreshTableData();
        break;
    }

  }

  handleActionsInTable(event: any) {
    // rowId relevent changes
    let rowId = event.data.row.id;
    let source: any;
    this.dataSource.forEach((plan: any) => {
      if (plan.id == rowId) {
        source = plan;
        plan.selectedAgentDevice = event.data.row.selectedAgentDevice;
      } else {
        plan.children?.forEach((child: any) => {
          if (child.id == rowId) {
            source = child;
            child.selectedAgentDevice = event.data.row.selectedAgentDevice;
          }
        })
      }
    });
    let currentPlan = this.testPlansForExecution.filter((plan: any) => {
      return plan.id == source.planId;
    })[0];
    let currentCase = currentPlan?.children.filter((child: any) => {
      return child.id == source.idWithoutRow;
    })[0];
    switch (event.data.column.key) {
      case 'agent':
        if(event.value.agentType) {
          source.agentId = event.value;
          source.agentType = event.value.agentType;
          source.placeholderText = event.value.label;
          currentCase.agentId = event.value.value;
          currentCase.agentType = event.value.agentType;
          currentCase.placeholderText = event.value.label;
          source.executionType = 'WEB';
          currentCase.executionType = 'WEB';
        } else {
          source.deviceId = event.value.id;
          source.agentType = undefined;
          source.placeholderText = event.value.label;
          currentCase.agentId = undefined;
          currentCase.agentType = undefined;
          currentCase.placeholderText = event.value.label;
          currentCase.deviceId = event.value.id;
          source.executionType = 'MOBILE';
          currentCase.executionType = 'MOBILE';
        }
        break;
      case 'browser':
        source.selectedBrowser = event.value.value;
        currentCase.browser = event.value.value;
        break;
      case 'version':
        source.selectedVersion = event.value.value;
        currentCase.selectedVersion = event.value.value;
        break;
    }

    this.zorroTableComponent.refreshTableData();
  }


  startExecution(releaseId?: any) {
    let plansList: any = [];
    let plan;
    for (let j = 0; j < this.testPlansForExecution.length; j++) {
      plan = this.testPlansForExecution[j];
      let currentPlan: any = {
        testPlanId: plan.id || '',
        testPlanName: plan.displayName,
        executionScripts: []
      };
      for (let i = 0; i < plan.children.length; i++) {
        let currentChild = plan.children[i];
        if(!currentChild.executionType) {
          this.toaster.pop({ type: 'warning', text: MessageEnum.TEST_CASE_SELECTION_REQUIRED });
          return;
        }
        if (currentChild.executionType === 'WEB' && (!currentChild.selectedVersion || !currentChild.browser || !(currentChild.agentId))) {
          this.toaster.pop({ type: 'error', text: MessageEnum.TEST_CASE_SELECTION_REQUIRED });
          return;
        }
        if (currentChild.executionType === 'MOBILE' && (!currentChild.selectedVersion || !currentChild.browser || !(currentChild.deviceId))) {
          this.toaster.pop({ type: 'error', text: MessageEnum.TEST_CASE_SELECTION_REQUIRED_DEVICE });
          return;
        }
        let obj: any = {
          sequence: i,
          id: currentChild.id,
          browser: currentChild.browser,
          version: currentChild.selectedVersion
        };
        if(currentChild.executionType === 'WEB') {
          obj.agentId =  currentChild.agentId === 'onDemand' ? null : currentChild.agentId;
          obj.agentType = currentChild.agentType;
          obj.executionType = currentChild.executionType;
        } else {
          obj.executionType = currentChild.executionType;
          obj.deviceId = currentChild.deviceId;
        }
        currentPlan.executionScripts.push(obj);
      }
      plansList.push(currentPlan);
    };

    //add releaseId
    this.restService.startExecution(this.projectId, this.automationProjectId, {
      testFailureAnalysis: this.isAnalysUp,
      selfHealing: this.isSelfHealingUp,
      releaseId: releaseId,
      automationExecutionPlanRequestDTOS: plansList
    }).subscribe((response) => {
      this.toaster.pop({ type: 'success', text: MessageEnum.EXECUTION_INITIATE_SUCCESS });
      this.sideNav.setTreeNode("testExecution");
    }, (error) => {
      this.toaster.pop({ type: 'error', text: error?.message || MessageEnum.EXECUTION_INITIATE_FAILURE });
    })
  }

  drop(event: any) {
    const data = event.item.data;
    
    if (!data.dragable) {
      return;
    }

    this.validateAndSetWarnings(data);
    this.updateAgentTypesIfNeeded(data);
    this.addToTestPlansForExecution(data);
    this.buildDataSourceFromObject();
  }

  private validateAndSetWarnings(data: any): void {
    if (data.tcgTestCaseResultId == null) {
      this.warningMessage = MessageEnum.TEST_CASE_MAP_ID_NOT_FOUND + data.displayName;
      return;
    }

    if (data.children?.length) {
      this.validateChildrenTestCases(data);
    } else {
      this.warningMessage = "";
    }
  }

  private validateChildrenTestCases(data: any): void {
    const hasInvalidChild = data.children.some(
      (child: any) => child.tcgTestCaseResultId == null
    );

    if (hasInvalidChild) {
      this.warningMessage = MessageEnum.TEST_CASE_MAP_ID_NOT_FOUND_PLAN + data.displayName;
    } else {
      this.warningMessage = "";
    }
  }

  private updateAgentTypesIfNeeded(data: any): void {
    if (data.children?.length) {
      data.children.forEach((child: any) => {
        child.agentType = this.agentIdWithType[child.agentId];
      });
    }
  }

  private addToTestPlansForExecution(data: any): void {
    if (data.children?.length) {
      this.testPlansForExecution.push(data);
    } else {
      this.addToAdHocTestPlan(data);
    }
  }

  private addToAdHocTestPlan(data: any): void {
    const customPlanIndex = this.findAdHocTestPlanIndex();

    if (customPlanIndex > -1) {
      this.testPlansForExecution[customPlanIndex].children.push(data);
    } else {
      this.createAdHocTestPlanWithData(data);
    }
  }

  private findAdHocTestPlanIndex(): number {
    return this.testPlansForExecution.findIndex(
      (plan: any) => plan.planName === 'AdHocTestplan'
    );
  }

  private createAdHocTestPlanWithData(data: any): void {
    this.testPlansForExecution.push({
      planName: 'AdHocTestplan',
      displayName: 'AdHocTestplan',
      children: [data]
    });
  }

  buildDataSourceFromObject() {
    this.dataSource = [];
    let plans = this.testPlansForExecution;
    let planIndex = 1;
    plans.forEach((data: any) => {
      let firstRow: any = {};
      for (let i = 0; i < data.children.length; i++) {
        let child = data.children[i];
        let row: any = {
          caseName: child.displayName,
          selectedAgent: child.agentId,
          selectedVersion: child.selectedVersion,
          selectedBrowser: child.browser,
          id: `${child.id}_${planIndex}_${i + 1}_row_${data?.id || ''}`,
          planId: data?.id,
          idWithoutRow: child.id,
          versionList: child.versionList
        }
        if (i == 0) {
          if (data.children.length > 1) {
            firstRow = { ...row, select: "", planName: data.displayName, children: [] };
          } else {
            firstRow = { ...row, select: "", planName: data.displayName };
          }

        } else {
          firstRow.children = [...firstRow.children, { ...row }];
        }
      }
      planIndex++;
      this.dataSource = [...this.dataSource, firstRow]
    });
  }

  modifyCaseTree() {
    let key = this.caseTreeSearch.toLowerCase();
    let result: any = []
    this.testCaseTreeData.forEach((node: any) => {
      let filterResult;
      let isNameContains;
      if (node.children?.length) {
        filterResult = [...node.children].filter((child: any) => {
          return child.name.toLowerCase().includes(key)
        });
        isNameContains = node.displayName.toLowerCase().includes(key);
        if (filterResult.length || isNameContains) {
          result.push({ ...node, children: filterResult })
        }
      } else if (node.name.toLowerCase().includes(key)) {
        result.push({ ...node });
      }
    });
    this.caseSearchResults = [...result];
  }

  modifyPlansTree() {
    let key = this.planTreeSearch.toLowerCase();
    let result: any = []
    this.testPlanTreeData.forEach((node: any) => {
      let filterResult;
      let isNameContains;
      if (node.children?.length) {
        filterResult = [...node.children].filter((child: any) => {
          return child.name.toLowerCase().includes(key)
        });
        isNameContains = node.displayName.toLowerCase().includes(key);
        if (filterResult.length || isNameContains) {
          result.push({ ...node, children: filterResult })
        }
      } else if (node.name.toLowerCase().includes(key)) {
        result.push({ ...node });
      }
    });
    this.planSearchResults = [...result];
  }

  handleSelect(event: any) {
    this.selectedPlans = [];
    this.selectedCases = [];

    //rowId relevent changesl
    event.data.forEach((row: any) => {
      if (row.select) {
        if (row.planName === 'AdHocTestplan') {
          this.selectedCases.push(row.id);
        } else {
          this.selectedPlans.push(row.id)
        }
      }
    })
  }

  executionWithoutRelease() {
    this.startExecution();
  }

  executionWithRelease() {
    this.openGenericModal();
  }

  openGenericModal() {
    console.log("releases", this.releases);
    var data = {
      displayName: "Start Execution with Release",
      saveBtnText: "Start",
    };

    const modalRef = this.modalService.open(ExecutionReleaseModalComponent, {
      centered: true,
      windowClass: "add-item-modal",
      backdrop: 'static',
    });
    modalRef.componentInstance.configs = {
      title: data.displayName,
      saveBtnText: data.saveBtnText,
      isEdit: false
    };
    // modalRef.componentInstance.fields = fields;
    modalRef.componentInstance.releases = this.releases;

    modalRef.result.then((result: any) => {
      console.log(result);
      if (result?.value) {
        //new method to exececute with release
        this.startExecution(result?.value);
      } else {
        this.toaster.pop({ type: 'error', text: MessageEnum.RELEASE_SELECTION_REQUIRED });
      }
    });
  }
}
